import { TimePicker as MuiTimePicker } from "@mui/x-date-pickers/TimePicker";
import TextField from "@mui/material/TextField";

type TimePickerProps = {
  disabled?: boolean;
  fullWidth?: boolean;
  size?: "medium" | "small";
  label: string;
  value?: Date | string;
  error?: boolean;
  helperText?: string;
  onChange: (value: string | Date, keyboardInputValue?: string) => void;
};

export function TimePicker({
  disabled,
  fullWidth,
  label,
  value,
  size,
  error,
  helperText,
  onChange,
}: TimePickerProps) {
  return (
    <MuiTimePicker
      disabled={disabled}
      label={label}
      value={value}
      onChange={onChange}
      renderInput={(params) => (
        <TextField
          {...params}
          fullWidth={fullWidth}
          size={size}
          error={error}
          helperText={helperText}
        />
      )}
    />
  );
}
